module.exports = __webpack_public_path__ + "387364b815d23c82861bfe97857a6803.fbx";